/**
 * Created by Andrey Popov on 1/28/26.
 */

const AdventureTutorialHelper = {
    createWaitStep: function (data) {
        return new TutorialStep({
            onStart: function () {
                const finish = cleverapps.once(this.finish.bind(this));

                if (data.event) {
                    cleverapps.tutorial.on(data.event, (options) => {
                        if (data.targets && !cleverapps.intersect(data.targets, options.unit, Unit.GetKey).length) {
                            return;
                        }

                        finish();
                    }, this);
                }

                cleverapps.timeouts.setTimeout(finish, data.duration || 5000);
            },

            onFinish: function () {
                Map2dLocation.currentLocation.counter.trigger();
            }
        });
    },

    createAdviceStep: function (data) {
        let dialogue;

        const createDialogue = () => {
            if (!dialogue && data.text) {
                dialogue = AdventureTutorialHelper.createMinimalDialogue(data);
            }
        };

        const removeDialogue = () => {
            if (dialogue) {
                dialogue.remove();
                dialogue = undefined;
            }
        };

        return new TutorialStep({
            onCheckConditions: function (options) {
                if (options.unit && !cleverapps.intersect(this.targets, options.unit, Unit.GetKey).length) {
                    return false;
                }

                if (options.fog && !cleverapps.intersect(this.targets, options.fog).length) {
                    return false;
                }

                if (options.advice && !cleverapps.intersect(this.type, options.advice).length) {
                    return false;
                }

                if (options.move) {
                    const move = Map2d.currentMap.advice.getCurrentMove();
                    return move && move.cells[0].x === options.move.x && move.cells[0].y === options.move.y;
                }

                return true;
            },

            onStart: function () {
                this.type = data.type;
                this.targets = data.targets = cleverapps.toArray(typeof data.targets === "function" ? data.targets() : data.targets) || [];

                Map2d.currentMap.advice.setLogic(data.type, data);

                if (!Map2d.currentMap.advice.hasHints()) {
                    if (typeof data.onSkip === "function") {
                        data.onSkip("noHints");
                    }
                    this.finish();
                    return;
                }

                const move = Map2d.currentMap.advice.findMove();

                if (!move) {
                    if (typeof data.onSkip === "function") {
                        data.onSkip("noMove");
                    }
                    this.finish();
                    return;
                }
                cleverapps.focusManager.compound(this.finish.bind(this), [
                    function (f) {
                        const scroll = Map2dScroller.currentScroller.getScrollView();
                        const mapView = Map2d.currentMap.getMapView();
                        const cell = move.cells[0];
                        const unit = Map2d.currentMap.getUnit(cell.x, cell.y);

                        Map2d.currentMap.showTile(cell.x, cell.y);

                        const target = (unit && unit.onGetView()) || mapView.getCell(cell.x, cell.y);

                        scroll.runAction(new cc.Sequence(
                            new cc.ScrollAction(target, {
                                visibleBox: {
                                    left: 0.3, right: 0.4, top: 0.15, bottom: 0.1
                                },
                                allowScrollWithFocus: true
                            }).easing(cc.easeInOut(2)),
                            new cc.CallFunc(() => {
                                if (data.force) {
                                    this.force = cleverapps.forces.create(unit.onGetView(), data.force);
                                }
                                f();
                            })
                        ));
                    }.bind(this),

                    function (f) {
                        cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);

                        const visibleControls = ["map2d", ...(data.controls || [])];
                        const hiddenControls = cleverapps.focusManager.controls.filter((control) => visibleControls.indexOf(control) === -1);

                        cleverapps.focusManager.hideControlsWhileFocused(hiddenControls);
                        cleverapps.focusManager.showControlsWhileFocused(visibleControls);

                        Map2d.currentMap.advice.startHint({
                            highlight: data.highlight,
                            delay: data.delay || AdventureTutorialHelper.ARROW_DELAY,
                            finger: {
                                delay: AdventureTutorialHelper.FINGER_DELAY,
                                repeatDelay: 2
                            }
                        });

                        cleverapps.eventBus.on("window_shown", removeDialogue, this);
                        Map2d.currentMap.customers.on("selectedCustomerChanged", removeDialogue, this);
                        cleverapps.eventBus.on("closeWindows", createDialogue, this);

                        createDialogue();
                        cleverapps.tutorial.on(data.type, (options) => {
                            const unit = options instanceof Unit ? options : options && options.unit;
                            if (unit && this.targets.length && !cleverapps.intersect(this.targets, unit, Unit.GetKey).length) {
                                return;
                            }

                            if (typeof data.onAdvance === "function") {
                                data.onAdvance(options);
                            }
                            f();
                        }, this);
                    }.bind(this)
                ]);
            },

            onFinish: function () {
                Map2d.currentMap.advice.stopHint();
                removeDialogue();
                if (this.force) {
                    this.force.close();
                }
                Map2dLocation.currentLocation.counter.trigger();
            }
        });
    },

    // the unit of a tutorial step, or the sources of its region when the map has no such unit there
    regionTargets: function (region, target) {
        const units = Map2d.currentMap.listAvailableUnitsInRegion(region);
        if (units.some((unit) => Unit.GetKey(unit) === Unit.GetKey(target))) {
            return [target];
        }

        return cleverapps.unique(units.filter((unit) => Families[unit.code].type === "advsource"), Unit.GetKey)
            .map((unit) => ({ code: unit.code, stage: unit.stage }));
    },

    createMinimalDialogue: function (data, items) {
        const dialogue = new MinimalDialogue({
            text: Messages.get(data.text),
            items,
            person: data.person,
            gravitate: data.gravitate,
            rects: Map2dAdviceView.listRects(data)
        });

        const scene = cleverapps.Scenes.GetRunningScene();
        scene.addChild(dialogue);
        dialogue.display();

        return dialogue;
    },

    createUnlockFogStep: function (data) {
        return new TutorialStep({
            onStart: function () {
                if (Map2dLocation.currentLocation.map.fogs.blocks[data.id]) {
                    Map2dLocation.currentLocation.map.fogs.blocks[data.id].unlock(() => {
                        const nextStepDelay = data.nextStepDelay * 1000 || 0;
                        if (nextStepDelay) {
                            Map2dLocation.currentLocation.counter.setTimeout(() => {}, nextStepDelay);
                        }

                        this.finish();
                    }, data.silent);
                } else {
                    this.finish();
                }
            },

            onFinish: function () {
                Map2dLocation.currentLocation.counter.trigger();
            }
        });
    }
};

AdventureTutorialHelper.ARROW_DELAY = 4.5;
AdventureTutorialHelper.FINGER_DELAY = 3.5;